<script>
export default {
  name: 'ArrowUpLineIcon',
  props: {
    size: { type: [Number, String], default: 24 },
    color: { type: String, default: 'currentColor' },
  },
}
</script>

<template>
  <!-- Seta para cima COM HASTE, de traço. O set só tinha chevrons
       (`arrow-up-light`, `arrow-up-new-ux` são triângulos sem haste) e ícones
       de envio em avião (`send`, `send-2`). Mesmo contrato de `tune.vue`. -->
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    >
      <path d="M12 19V5" />
      <path d="M5 12L12 5L19 12" />
    </g>
  </svg>
</template>
